import * as THREE from 'three';
import { VRMLLoader } from 'three/examples/jsm/loaders/VRMLLoader';
import { FikoObje3D } from './FikoObje3D';
import { FikoSahne } from './FikoSahne';
import { FikoCizimWRL } from './FikoThreeCam/FikoCizimWRL';
import { FikoOperasyon } from './FikoThreeCam/Fikoperasyon';
import { FikoVektor3D } from './FikoVektor3d';
import { FikoEksen } from './FikoEksen';
import { FikoGrupCizim } from './FikoGrupCizim';
import { FikoImporterWRL } from './FikoImporter.WRL';
import { FikoCizimYalin } from './FikoCizimYalin';
import { Fikogram } from './FikoThreeCam/Fikogram';
import { FikoImporterAPTCAT } from './FikoImporter.APTCAT';
import { FikoAPTCAT } from './FikoThreeCam/FikoAPTCAD';

export class FikoImporterFikoOpGL {
    loader: THREE.FileLoader = new THREE.FileLoader();
    public onProgress?: (mesaj: string, progress: number) => void;

    constructor(public sahne?: FikoSahne) {

    }


    async alDosyadan(dosya: any): Promise<FikoOperasyon> {
        return new Promise((resolve, reject) => {
            let _rslt: FikoOperasyon;
            this.loader.load(URL.createObjectURL(dosya), (dosyaStr: any) => {
                let _json = JSON.parse(dosyaStr);

                _rslt = new FikoOperasyon(this.sahne, _json.ismi);
                _rslt.userData['aciklama'] = _json.aciklama;

                _rslt.remove(_rslt.islemeEkseni)

                const islemeEkseni = new FikoEksen(
                    this.sahne,
                    "İşleme Ekseni",
                    new FikoVektor3D().fromArray(_json.islemeEkseni.merkez),
                    new FikoVektor3D().fromArray(_json.islemeEkseni.x),
                    new FikoVektor3D().fromArray(_json.islemeEkseni.y),
                    new FikoVektor3D().fromArray(_json.islemeEkseni.z),
                )
                _rslt.children = [
                    islemeEkseni,
                    ..._rslt.children
                ]

                const grupCizim = new FikoGrupCizim(this.sahne, "İşleme Datası")
                _rslt.cizimler.ekle(grupCizim);

                const importerWRL = new FikoImporterWRL(this.sahne);
                importerWRL.onProgress = this.onProgress;
                importerWRL.parcala(_json.cizim).then((snc: any) => {
                    for (let i = 0; i < snc.length; i++) {
                        const element = snc[i];
                        grupCizim.add(new FikoCizimYalin(
                            this.sahne,
                            "FikoÇizim" + String(i),
                            element.yuzeyler,
                            element.cizgiler,
                            element.vertex
                        ))
                    }
                })


                for (let i = 0; i < _json.programlar.length; i++) {
                    let _aprg = _json.programlar[i];

                    if (_aprg.apt != null) {
                        // console.log(_aprg.apt)
                        // prg.isleAptArray(_aprg.apt);

                        let importerApt = new FikoImporterAPTCAT(this.sahne);
                        let aptPort = importerApt.isleArray(_aprg.apt);

                        let apt = new FikoAPTCAT(this.sahne);

                        apt.tarihi = aptPort.tarihi;
                        apt.programIsmi = aptPort.programIsmi;
                        apt.kureMerkezi = aptPort.kureMerkezi;
                        apt.operasyonIsmi = aptPort.operasyonIsmi;
                        apt.eksenKoord = aptPort.eksenKoord;
                        apt.aktiviteler = aptPort.aktiviteler;
                        apt.eksen = aptPort.eksen;
                        apt.takimYolu = aptPort.takimYolu;

                        apt.ekle(aptPort.takimYolu)

                        apt.name = _aprg.ismi;
                        apt.userData['aciklama'] = _aprg.aciklama;

                        _rslt.programlar.ekle(apt);

                        // apt.takimYolu.noktalar = null;
                        apt = null;

                        importerApt = null;
                        aptPort = null;
                    } else {
                        let prg = new Fikogram(this.sahne, _aprg.ismi);
                        prg.userData['aciklama'] = _aprg.aciklama;
                        _rslt.programlar.ekle(prg);

                        prg = null;
                    }

                    _aprg.apt = null;
                    _aprg = null;
                }

                _rslt.islemeEkseni.parent = _rslt;

                resolve(_rslt);

                _json = null;
            })


        });
    }

    parcala(dosya: any): FikoOperasyon {
        // return new Promise((resolve, reject) => {
        let _rslt: FikoOperasyon;
        // this.loader.load(URL.createObjectURL(dosya), (dosyaStr: any) => {
        const _json = JSON.parse(dosya);
        // console.log(_json)

        _rslt = new FikoOperasyon(this.sahne, _json.ismi);
        _rslt.userData['aciklama'] = _json.aciklama;

        _rslt.remove(_rslt.islemeEkseni)

        const islemeEkseni = new FikoEksen(
            this.sahne,
            "İşleme Ekseni",
            new FikoVektor3D().fromArray(_json.islemeEkseni.merkez),
            new FikoVektor3D().fromArray(_json.islemeEkseni.x),
            new FikoVektor3D().fromArray(_json.islemeEkseni.y),
            new FikoVektor3D().fromArray(_json.islemeEkseni.z),
        )
        _rslt.children = [
            islemeEkseni,
            ..._rslt.children
        ]

        const grupCizim = new FikoGrupCizim(this.sahne, "İşleme Datası")
        _rslt.cizimler.ekle(grupCizim);

        const importerWRL = new FikoImporterWRL(this.sahne);
        importerWRL.onProgress = this.onProgress;
        importerWRL.parcala(_json.cizim).then((snc: any) => {
            for (let i = 0; i < snc.length; i++) {
                const element = snc[i];
                grupCizim.add(new FikoCizimYalin(
                    this.sahne,
                    "FikoÇizim" + String(i),
                    element.yuzeyler,
                    element.cizgiler,
                    element.vertex
                ))
            }
        })


        for (let i = 0; i < _json.programlar.length; i++) {
            let _aprg = _json.programlar[i];

            if (_aprg.apt != null) {
                // console.log(_aprg.apt)
                // prg.isleAptArray(_aprg.apt);

                let importerApt = new FikoImporterAPTCAT(this.sahne);
                let aptPort = importerApt.isleArray(_aprg.apt);

                let apt = new FikoAPTCAT(this.sahne);

                apt.tarihi = aptPort.tarihi;
                apt.programIsmi = aptPort.programIsmi;
                apt.kureMerkezi = aptPort.kureMerkezi;
                apt.operasyonIsmi = aptPort.operasyonIsmi;
                apt.eksenKoord = aptPort.eksenKoord;
                apt.aktiviteler = aptPort.aktiviteler;
                apt.eksen = aptPort.eksen;
                apt.takimYolu = aptPort.takimYolu;

                apt.ekle(aptPort.takimYolu)

                apt.name = _aprg.ismi;
                apt.userData['aciklama'] = _aprg.aciklama;

                _rslt.programlar.ekle(apt);

                apt = null;

                importerApt = null;
                aptPort = null;
            } else {
                let prg = new Fikogram(this.sahne, _aprg.ismi);
                prg.userData['aciklama'] = _aprg.aciklama;
                _rslt.programlar.ekle(prg);

                prg = null;
            }
            _aprg.apt = null;
            _aprg = null;
        }


        _rslt.islemeEkseni.parent = _rslt;

        return _rslt;
        // })


        // });
    }


}